






































import { Vue, Component } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { SaveCanalDeVendasUseCase } from '@/usecases'
import { CanaldeVendas, ParametrosDeAtualizacaoCanaldeVendas } from '@/models'

@Component
export default class DialogoDeEdicaoDeCanalDeVendas extends Vue {
	canalDeVendas: CanaldeVendas | null = null
	mostra = false
	salvando = false
	saveCanalDeVendasUseCase = new SaveCanalDeVendasUseCase()

	canalDeVendasEmEdicao: CanaldeVendas = {
		id: null,
		nome: '',
		imageURL: '',
	}

	parametros: ParametrosDeAtualizacaoCanaldeVendas = {
		id: null,
		nome: '',
		file: null,
	}

	mostrar(canalDeVendas: CanaldeVendas) {
		this.mostra = true
		this.canalDeVendasEmEdicao.id = canalDeVendas.id
		this.canalDeVendasEmEdicao.nome = canalDeVendas.nome
		this.canalDeVendasEmEdicao.imageURL = canalDeVendas.imageURL
	}
	esconder() {
		this.mostra = false
	}
	async salvar() {
		try {
			this.salvando = true
			let canalDeVendas: CanaldeVendas
			this.parametros = {
				...this.parametros,
				id: this.canalDeVendasEmEdicao.id,
				nome: this.canalDeVendasEmEdicao.nome,
			}
			if (!this.parametros.nome) {
				AlertModule.setError('O nome do canal de vendas é obrigatório.')
				return
			}
			if (this.canalDeVendasEmEdicao.id) {
				canalDeVendas = await this.saveCanalDeVendasUseCase.update(this.parametros)
			} else {
				if (!this.parametros.file) {
					AlertModule.setError('É necessário selecionar uma imagem para o canal de vendas.')
					return
				} else {
					canalDeVendas = await this.saveCanalDeVendasUseCase.create(this.parametros)
				}
			}
			this.$emit('confirmado', canalDeVendas)
			this.mostra = false
			AlertModule.setSuccess('Bandeira salva com sucesso')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
		}
	}

	onImagemSelecionada(file: File | File[] | null) {
		if (!file) {
			this.canalDeVendasEmEdicao.imageURL = ''
			this.parametros.file = null
			return
		}
		const arquivo = Array.isArray(file) ? file[0] : file
		const reader = new FileReader()
		reader.onload = (e: any) => {
			this.canalDeVendasEmEdicao.imageURL = e.target.result
		}
		this.parametros.file = arquivo
		reader.readAsDataURL(arquivo)
	}
}
